// Rubrica gráfica, não certificado digital. Falhas nunca viram uma linha vazia.
export const prepareDocumentSignature = (source, required = true) => new Promise((resolve, reject) => {
  if (!source) {
    if (!required) { resolve(null); return; }
    reject(new Error('Cadastre sua assinatura em Configurações antes de emitir o documento.'));
    return;
  }
  if (!/^data:image\/(png|jpeg|jpg);base64,/i.test(source)) {
    reject(new Error('Assinatura inválida. Redesenhe e salve sua assinatura em Configurações.'));
    return;
  }
  const image = new Image();
  const timer = setTimeout(() => reject(new Error('Não foi possível carregar a assinatura. Tente novamente.')), 10000);
  image.onload = () => {
    clearTimeout(timer);
    try {
      if (!image.width || !image.height || image.width * image.height > 1000000) {
        throw new Error('Assinatura com dimensões inválidas. Redesenhe em Configurações.');
      }
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let ink = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        if (Math.min(pixels[i], pixels[i + 1], pixels[i + 2]) < 220) ink++;
      }
      if (ink < 8) throw new Error('A assinatura está em branco. Redesenhe em Configurações.');
      // PNG sem redimensionamento/perda: permite ao servidor conferir os pixels da rubrica.
      resolve(canvas.toDataURL('image/png'));
    } catch (error) { reject(error); }
  };
  image.onerror = () => {
    clearTimeout(timer);
    reject(new Error('Não foi possível ler a assinatura. Redesenhe em Configurações.'));
  };
  image.src = source;
});

export const fetchDocumentSignature = async (authFetch, profissionalId) => {
  if (!profissionalId) throw new Error('Selecione o vínculo profissional antes de emitir.');
  const response = await authFetch(`/profissionais/${profissionalId}/assinatura`);
  return prepareDocumentSignature(response.data?.assinatura_url);
};

export const addDocumentSignature = (doc, png, y, width = 60, height = 20) => {
  if (!png) throw new Error('Assinatura obrigatória não foi carregada.');
  const dimensions = doc.getImageProperties(png);
  const scale = Math.min(width / dimensions.width, height / dimensions.height);
  const w = dimensions.width * scale;
  const h = dimensions.height * scale;
  doc.addImage(png, 'PNG', (doc.internal.pageSize.getWidth() - w) / 2, y, w, h, undefined, 'FAST');
  return h;
};